function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminList = void 0;
Object.defineProperty(exports, "AdminListTypes", {
  enumerable: true,
  get: function get() {
    return _AdminListTypes.AdminListTypes;
  }
});
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _components = require("../../components");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _AdminListController = require("./AdminListController");
var _styles2 = require("../../styles");
var _AdminListActions = require("./AdminListActions");
var _locales = require("../../locales");
var _utils = require("../../utils");
var _reactNative = require("react-native-web");
var _AdminListTypes = require("./AdminListTypes");
var _getLocaleKey = require("./getLocaleKey");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var AdminList = exports.AdminList = (0, _react.memo)(function (_ref) {
  var type = _ref.type,
    _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _AdminListController.AdminListController() : _ref$controller,
    organizationId = _ref.organizationId,
    teamId = _ref.teamId,
    teamAdminPageLinkUrl = _ref.teamAdminPageLinkUrl,
    style = _ref.style;
  (0, _useLang.useLang)();
  (0, _locales.useErrorLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var navigationContext = (0, _utils.useNavigationContext)();
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _hideRemoveDialog = _useState2[0],
    _setHideRemoveDialog = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _hideCreateTeams1Dialog = _useState4[0],
    _setHideCreateTeams1Dialog = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _hideCreateTeams2Dialog = _useState6[0],
    _setHideCreateTeams2Dialog = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    _createTeamsValue = _useState8[0],
    _setCreateTeamsValue = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    _hideEditMemberDialog = _useState10[0],
    _setHideEditMemberDialog = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    _editMemberRoleIsAdmin = _useState12[0],
    _setEditMemberRoleIsAdmin = _useState12[1];
  var _useState13 = (0, _react.useState)(''),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    _editMemberTeamId = _useState14[0],
    _setEditMemberTeamId = _useState14[1];
  var _controller$useContro = controller.useController({
      organizationId: organizationId,
      teamId: teamId,
      type: type
    }),
    data = _controller$useContro.data,
    selectedItems = _controller$useContro.selectedItems,
    setSelectedItem = _controller$useContro.setSelectedItem,
    setSelectedItems = _controller$useContro.setSelectedItems,
    totalItems = _controller$useContro.totalItems,
    currentPage = _controller$useContro.currentPage,
    setCurrentPage = _controller$useContro.setCurrentPage,
    setSearchValue = _controller$useContro.setSearchValue,
    refetch = _controller$useContro.refetch,
    isLoading = _controller$useContro.isLoading,
    createTeams = _controller$useContro.createTeams,
    removeItems = _controller$useContro.removeItems,
    updateItems = _controller$useContro.updateItems,
    updateMembershipRequests = _controller$useContro.updateMembershipRequests,
    hasSearchValue = _controller$useContro.hasSearchValue,
    itemsPerPage = _controller$useContro.itemsPerPage,
    setItemsPerPage = _controller$useContro.setItemsPerPage,
    teamsList = _controller$useContro.teamsList,
    teamsFilter = _controller$useContro.teamsFilter,
    selectedTeam = _controller$useContro.selectedTeam,
    setTeam = _controller$useContro.setTeam,
    setMemberTeam = _controller$useContro.setMemberTeam;
  var _localeKey = (0, _getLocaleKey.getLocaleKey)(type);
  var WorkplaceImage = (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Workplace.svg")
    }, props));
  });
  var _getTags = (0, _react.useCallback)(function (isAdmin, teams) {
    var _tags = [];
    if (teams) {
      _tags = teams.map(function (tag) {
        return {
          label: tag.name,
          textColor: COLORS.white,
          backgroundColor: tag.admin ? COLORS.goblin : COLORS.aubergine,
          Icon: tag.admin ? _components.Icons.Padlock : undefined
        };
      });
    }
    if (isAdmin) {
      _tags.unshift({
        label: type === _AdminListTypes.AdminListTypes.teamMembers ? 'Team admin' : 'Org admin',
        textColor: COLORS.white,
        backgroundColor: COLORS.goblin,
        Icon: _components.Icons.Padlock
      });
    }
    return _tags;
  }, [COLORS.aubergine, COLORS.goblin, COLORS.white, type]);
  var _items = (0, _react.useMemo)(function () {
    if (!data || data.length === 0) return [];
    switch (type) {
      case _AdminListTypes.AdminListTypes.organizationMembers:
      case _AdminListTypes.AdminListTypes.teamMembers:
        {
          return data == null ? void 0 : data.map(function (item) {
            return {
              id: item.id,
              primaryText: item.fullName,
              secondaryText: item.email,
              avatar: item.avatar,
              tags: _getTags(item.admin, item.teams),
              onSelect: setSelectedItem
            };
          });
        }
      case _AdminListTypes.AdminListTypes.organizationPendingMembers:
      case _AdminListTypes.AdminListTypes.teamPendingMembers:
        {
          return data == null ? void 0 : data.map(function (item) {
            return {
              id: item.id,
              primaryText: item.fullName,
              secondaryText: item.email,
              tertiaryText: item.verificationAnswer,
              avatar: item.avatar,
              onSelect: setSelectedItem
            };
          });
        }
      case _AdminListTypes.AdminListTypes.organizationTeams:
        {
          return data == null ? void 0 : data.map(function (item) {
            return {
              id: item.id,
              primaryText: item.name,
              avatar: item.logo || WorkplaceImage,
              actionLabel: t('adminList:teams.viewLabel'),
              actionOnPress: function actionOnPress() {
                if (!teamAdminPageLinkUrl || !item.id) return;
                var _url = (0, _utils.ReplaceParam)(teamAdminPageLinkUrl, item.id);
                navigationContext.navigate(_url);
              },
              onSelect: setSelectedItem
            };
          });
        }
    }
  }, [WorkplaceImage, _getTags, data, navigationContext, setSelectedItem, t, teamAdminPageLinkUrl, type]);
  var _pages = Math.ceil(totalItems / itemsPerPage);
  var _hasItems = !!_items && _items.length > 0;
  var _hasSelectedItems = !!selectedItems && selectedItems.length > 0;
  var _hasPagination = _pages > 1;
  var _searchOnPress = function _searchOnPress(value) {
    setSearchValue(value);
  };
  var _paginationOnPress = function _paginationOnPress(index) {
    setCurrentPage(index);
  };
  var _selectAllOnPress = function _selectAllOnPress() {
    setSelectedItems(_items.map(function (item) {
      return item.id;
    }));
  };
  var _deselectAllOnPress = function _deselectAllOnPress() {
    setSelectedItems([]);
  };
  var _showMessage = function _showMessage(text) {
    (0, _components.ShowMessage)({
      type: _components.MessageType.notice,
      isCloseable: true,
      text: text
    });
  };
  var _showErrorMessage = function _showErrorMessage() {
    (0, _components.ShowMessage)({
      isCloseable: true,
      text: t('error:default')
    });
  };
  var _approveOnPress = function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _success;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return updateMembershipRequests(data, selectedItems, true);
          case 2:
            _success = _context.sent;
            if (!_success) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return refetch();
          case 6:
            _showMessage(t("adminList:".concat(_localeKey, ".messages.approveSuccess")));
            _context.next = 10;
            break;
          case 9:
            _showErrorMessage();
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _approveOnPress() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _declineOnPress = function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _success;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return updateMembershipRequests(data, selectedItems, false);
          case 2:
            _success = _context2.sent;
            if (!_success) {
              _context2.next = 9;
              break;
            }
            _context2.next = 6;
            return refetch();
          case 6:
            _showMessage(t("adminList:".concat(_localeKey, ".messages.declineSuccess")));
            _context2.next = 10;
            break;
          case 9:
            _showErrorMessage();
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function _declineOnPress() {
      return _ref3.apply(this, arguments);
    };
  }();
  var _createTeams = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _success;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (organizationId) {
              _context3.next = 3;
              break;
            }
            _showErrorMessage();
            return _context3.abrupt("return");
          case 3:
            _context3.next = 5;
            return createTeams(_createTeamsValue.split('\n'), organizationId);
          case 5:
            _success = _context3.sent;
            _setHideCreateTeams1Dialog(true);
            _setHideCreateTeams2Dialog(true);
            _setCreateTeamsValue('');
            if (!_success) {
              _context3.next = 15;
              break;
            }
            _context3.next = 12;
            return refetch();
          case 12:
            _showMessage(t("adminList:".concat(_localeKey, ".createTeams.success")));
            _context3.next = 16;
            break;
          case 15:
            _showErrorMessage();
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function _createTeams() {
      return _ref4.apply(this, arguments);
    };
  }();
  var _createTeamsReview = function _createTeamsReview() {
    if (_createTeamsValue === '') return;
    _setCreateTeamsValue(function (prevValue) {
      var _uniqueValue = prevValue.split('\n').filter(function (value, index, array) {
        return array.indexOf(value) === index;
      });
      return _uniqueValue.join('\n');
    });
    _setHideCreateTeams2Dialog(false);
  };
  var _editMemberRole = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _key, _success;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _key = 'admin';
            _context4.next = 3;
            return updateItems(data, selectedItems, _key, _editMemberRoleIsAdmin);
          case 3:
            _success = _context4.sent;
            _setHideEditMemberDialog(true);
            if (!_success) {
              _context4.next = 12;
              break;
            }
            _context4.next = 8;
            return refetch();
          case 8:
            setSelectedItems([]);
            _showMessage(t("adminList:members.editMember.success"));
            _context4.next = 13;
            break;
          case 12:
            _showErrorMessage();
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function _editMemberRole() {
      return _ref5.apply(this, arguments);
    };
  }();
  var _editMemberTeam = function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _groupMembershipIds, _success;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _groupMembershipIds = data.filter(function (item) {
              return selectedItems.includes(item.id);
            }).map(function (item) {
              return item.groupMembershipId;
            });
            _context5.next = 3;
            return setMemberTeam({
              groupMembershipIds: _groupMembershipIds,
              teamId: _editMemberTeamId
            });
          case 3:
            _success = _context5.sent;
            _setHideEditMemberDialog(true);
            if (!_success) {
              _context5.next = 12;
              break;
            }
            _context5.next = 8;
            return refetch();
          case 8:
            setSelectedItems([]);
            _showMessage(t("adminList:members.editMember.success"));
            _context5.next = 13;
            break;
          case 12:
            _showErrorMessage();
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function _editMemberTeam() {
      return _ref6.apply(this, arguments);
    };
  }();
  var _remove = function () {
    var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _success;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return removeItems(data, selectedItems);
          case 2:
            _success = _context6.sent;
            _setHideRemoveDialog(true);
            if (!_success) {
              _context6.next = 11;
              break;
            }
            _context6.next = 7;
            return refetch();
          case 7:
            setSelectedItems([]);
            _showMessage(t("adminList:".concat(_localeKey, ".remove.success")));
            _context6.next = 12;
            break;
          case 11:
            _showErrorMessage();
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function _remove() {
      return _ref7.apply(this, arguments);
    };
  }();
  var _onShowEditMemberDialog = function _onShowEditMemberDialog() {
    if (_reactNative.Platform.OS === 'web') {
      document.documentElement.setAttribute('locked', 'true');
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (_hideEditMemberDialog) {
      _setEditMemberRoleIsAdmin(false);
      if (_reactNative.Platform.OS === 'web') {
        document.documentElement.removeAttribute('locked');
      }
    }
  }, [_hideEditMemberDialog]);
  if ((type === _AdminListTypes.AdminListTypes.organizationPendingMembers || type === _AdminListTypes.AdminListTypes.teamPendingMembers) && !_hasItems && !hasSearchValue) {
    return null;
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_components.View, {
      style: [styles.container, style],
      testID: "AdminList",
      children: [(0, _jsxRuntime.jsx)(_components.Heading, {
        level: 3,
        style: styles.title,
        children: t("adminList:".concat(_localeKey, ".title"))
      }), (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.topSection,
        spacer: spacing.normal,
        children: [(0, _jsxRuntime.jsx)(_components.SearchInput, {
          label: t("adminList:".concat(_localeKey, ".title")),
          onPress: _searchOnPress
        }), (0, _jsxRuntime.jsx)(_AdminListActions.AdminListActions, {
          type: type,
          hasItems: _hasItems,
          hasSelectedItems: _hasSelectedItems,
          selectAllOnPress: _selectAllOnPress,
          deselectAllOnPress: _deselectAllOnPress,
          createOnPress: function createOnPress() {
            return _setHideCreateTeams1Dialog(false);
          },
          editOnPress: function editOnPress() {
            return _setHideEditMemberDialog(false);
          },
          removeOnPress: function removeOnPress() {
            return _setHideRemoveDialog(false);
          },
          approveOnPress: _approveOnPress,
          declineOnPress: _declineOnPress
        })]
      }), type === _AdminListTypes.AdminListTypes.organizationMembers && (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.filters,
        spacer: spacing.normal,
        children: [(0, _jsxRuntime.jsxs)(_components.View, {
          style: styles.dropdown,
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.dropdownSelectText,
            children: t('adminList:filters.sortBy.label')
          }), (0, _jsxRuntime.jsx)(_components.Select, {
            items: (teamsFilter == null ? void 0 : teamsFilter.map(function (item) {
              return {
                label: item.name,
                id: item.id
              };
            })) || [],
            selectedId: selectedTeam,
            label: t('adminList:filters.sortBy.label'),
            hideLabel: true,
            emptyLabel: t('adminList:filters.sortBy.emptyLabel'),
            onSelect: setTeam,
            disabled: isLoading || !teamsFilter || teamsFilter.length === 0,
            style: styles.dropdownSelect,
            type: _components.SelectType.outline
          })]
        }), (0, _jsxRuntime.jsxs)(_components.View, {
          style: styles.dropdown,
          children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.dropdownSelectText,
            children: t('adminList:filters.display.label')
          }), (0, _jsxRuntime.jsx)(_components.Select, {
            items: _AdminListController.itemsPerPageOptions.map(function (item) {
              return {
                label: "".concat(item, " ").concat(t('adminList:filters.display.suffix')),
                value: item.toString()
              };
            }),
            label: t('adminList:filters.display.label'),
            hideLabel: true,
            onSelect: setItemsPerPage,
            disabled: isLoading,
            selectedId: itemsPerPage.toString(),
            style: styles.dropdownSelect,
            type: _components.SelectType.outline
          })]
        })]
      }), isLoading ? (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {
        style: styles.list
      }) : (0, _jsxRuntime.jsx)(_components.List, {
        items: _items,
        selectedItems: selectedItems,
        emptyMessage: t("adminList:".concat(_localeKey, ".messages.empty")),
        style: styles.list
      }), _hasPagination && (0, _jsxRuntime.jsx)(_components.Pagination, {
        currentItem: currentPage,
        totalItems: _pages,
        label: t("adminList:".concat(_localeKey, ".title")),
        onPress: _paginationOnPress,
        isNumbered: true,
        showEllipsis: true,
        style: styles.pagination
      })]
    }), (0, _jsxRuntime.jsx)(_components.FullScreenDialog, {
      isHidden: _hideRemoveDialog,
      title: t("adminList:".concat(_localeKey, ".remove.title")),
      primaryActionCallback: _remove,
      primaryActionLabel: t("adminList:".concat(_localeKey, ".remove.submit")),
      closeLabel: t("adminList:".concat(_localeKey, ".remove.cancel")),
      closeCallback: function closeCallback() {
        return _setHideRemoveDialog(true);
      },
      hideBox: true,
      trackingLabel: "AdminList Remove"
    }), (0, _jsxRuntime.jsxs)(_components.FullScreenDialog, {
      isHidden: _hideEditMemberDialog,
      title: t("adminList:members.editMember.title"),
      closeLabel: t("adminList:members.editMember.cancel"),
      closeCallback: function closeCallback() {
        return _setHideEditMemberDialog(true);
      },
      hideBox: true,
      trackingLabel: "AdminList Edit Member",
      onShow: _onShowEditMemberDialog,
      children: [(0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.editMemberRoleContainer,
        children: [(0, _jsxRuntime.jsx)(_components.Field, {
          label: t("adminList:members.editMember.role.label"),
          children: (0, _jsxRuntime.jsx)(_components.Toggle, {
            value: _editMemberRoleIsAdmin,
            onChange: function onChange(value) {
              return _setEditMemberRoleIsAdmin(value);
            },
            trueLabel: t("adminList:members.editMember.roles.admin", {
              type: type === _AdminListTypes.AdminListTypes.teamMembers ? 'Team' : 'Org'
            }),
            falseLabel: t("adminList:members.editMember.roles.member"),
            accessibilityLabel: t("adminList:members.editMember.label")
          })
        }), (0, _jsxRuntime.jsx)(_components.Button, {
          type: _components.ButtonType.brand,
          label: t("adminList:members.editMember.role.submit"),
          onPress: _editMemberRole
        })]
      }), type === _AdminListTypes.AdminListTypes.organizationMembers && !!teamsList && teamsList.length > 0 && (0, _jsxRuntime.jsxs)(_components.View, {
        style: styles.editMemberTeamContainer,
        children: [(0, _jsxRuntime.jsx)(_components.Select, {
          items: (teamsList == null ? void 0 : teamsList.map(function (item) {
            return {
              label: item.name,
              id: item.id
            };
          })) || [],
          selectedId: selectedTeam,
          label: t("adminList:members.editMember.team.label"),
          emptyLabel: t("adminList:members.editMember.team.emptyLabel"),
          onSelect: _setEditMemberTeamId,
          disabled: isLoading || !teamsList || teamsList.length === 0
        }), (0, _jsxRuntime.jsx)(_components.Button, {
          type: _components.ButtonType.brand,
          label: t("adminList:members.editMember.team.submit"),
          onPress: _editMemberTeam,
          state: {
            disabled: _editMemberTeamId === ''
          }
        })]
      })]
    }), (0, _jsxRuntime.jsx)(_components.FullScreenDialog, {
      isHidden: _hideCreateTeams1Dialog,
      title: t("adminList:".concat(_localeKey, ".createTeams.step1.title")),
      primaryActionCallback: _createTeamsReview,
      primaryActionLabel: t("adminList:".concat(_localeKey, ".createTeams.step1.submit")),
      primaryActionDisabled: _createTeamsValue === '',
      closeLabel: t("adminList:".concat(_localeKey, ".createTeams.step1.cancel")),
      closeCallback: function closeCallback() {
        _setHideCreateTeams1Dialog(true);
        _setCreateTeamsValue('');
      },
      hideBox: true,
      trackingLabel: "AdminList Create Teams Step 1",
      children: (0, _jsxRuntime.jsx)(_components.TextInput, {
        label: t("adminList:".concat(_localeKey, ".createTeams.step1.label")),
        description: t("adminList:".concat(_localeKey, ".createTeams.step1.description")),
        placeholder: t("adminList:".concat(_localeKey, ".createTeams.step1.placeholder")),
        multiline: true,
        value: _createTeamsValue,
        onChangeText: function onChangeText(value) {
          return _setCreateTeamsValue(value);
        }
      })
    }), (0, _jsxRuntime.jsx)(_components.FullScreenDialog, {
      isHidden: _hideCreateTeams2Dialog,
      title: t("adminList:".concat(_localeKey, ".createTeams.step2.title")),
      primaryActionCallback: _createTeams,
      primaryActionLabel: t("adminList:".concat(_localeKey, ".createTeams.step2.submit")),
      closeLabel: t("adminList:".concat(_localeKey, ".createTeams.step2.cancel")),
      closeCallback: function closeCallback() {
        return _setHideCreateTeams2Dialog(true);
      },
      hideBox: true,
      trackingLabel: "AdminList Create Teams Step 2",
      children: (0, _jsxRuntime.jsx)(_components.Text, {
        containerStyle: styles.createReviewTextContainer,
        children: _createTeamsValue
      })
    })]
  });
});